/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./federatedAuthClientConfig.vue?vue&type=template&id=4585351a&scoped=true"
import script from "./federatedAuthClientConfig.vue?vue&type=script&lang=js"
export * from "./federatedAuthClientConfig.vue?vue&type=script&lang=js"
import style0 from "./federatedAuthClientConfig.vue?vue&type=style&index=0&id=4585351a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4585351a",
  null
  
)

export default component.exports